/* TANTRUMS 2026 — storefront behaviour */
(function () {
  'use strict';

  /* ---- Hero crossfade ---- */
  var frames = document.querySelectorAll('.tt-hero-frame');
  if (frames.length > 1) {
    var f = 0;
    setInterval(function () {
      frames[f].classList.remove('on');
      f = (f + 1) % frames.length;
      frames[f].classList.add('on');
    }, 4000);
  }

  /* ---- Product: variant selection ---- */
  var form = document.querySelector('[data-product-form]');
  if (form) {
    var data = JSON.parse(document.getElementById('tt-variants').textContent);
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var atc = form.querySelector('.tt-atc');
    var colorEl = document.querySelector('[data-color-name]');
    var stockNote = form.querySelector('[data-stock-note]');
    var copyEl = document.querySelector('[data-copy]');

    /* Copy can differ per colourway; absent metafield just leaves it alone. */
    var copyMap = null;
    var copyTag = document.getElementById('tt-color-copy');
    if (copyTag) {
      try { copyMap = JSON.parse(copyTag.textContent); } catch (e) {}
    }

    /* Products that offer a stockist route keep their sold-out sizes
       selectable: choosing one is how the shopper gets told where to buy it.
       Everywhere else a sold-out size stays disabled, as before. */
    var sizesWrap = form.querySelector('.tt-sizes');
    var allowOut = !!(sizesWrap && sizesWrap.hasAttribute('data-allow-out'));

    function selected(group) {
      var el = document.querySelector('[data-opt="' + group + '"][aria-pressed="true"]');
      return el ? el.dataset.value : null;
    }

    function match() {
      var c = selected('color'), s = selected('size');
      return data.find(function (v) {
        return (c === null || v.color === c) && (s === null || v.size === s);
      });
    }

    function refresh() {
      var v = match();
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      var out = !v.available;
      atc.disabled = out;
      atc.textContent = out ? 'Sold out' : 'Add to cart';
      if (stockNote) stockNote.hidden = !out;

      /* mark sizes with no stock in the chosen colour */
      var c = selected('color');
      document.querySelectorAll('[data-opt="size"]').forEach(function (b) {
        var hit = data.find(function (v2) {
          return v2.size === b.dataset.value && (c === null || v2.color === c);
        });
        var gone = !hit || !hit.available;

        if (allowOut) {
          b.disabled = false;
          if (gone) {
            b.setAttribute('data-out', '');
          } else {
            b.removeAttribute('data-out');
          }
        } else {
          b.disabled = gone;
        }
      });
    }

    /* If the size in hand is gone in the newly chosen colour, move to one that
       is actually in stock rather than leaving the shopper on a dead variant. */
    function reseatSize(color) {
      var picked = selected('size');
      if (!picked) return;
      var hit = data.find(function (v) { return v.color === color && v.size === picked; });
      if (hit && hit.available) return;

      var next = data.find(function (v) { return v.color === color && v.available; });
      if (!next) return;
      document.querySelectorAll('[data-opt="size"]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.value === next.size));
      });
    }

    document.querySelectorAll('[data-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.dataset.opt;
        document.querySelectorAll('[data-opt="' + group + '"]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        btn.setAttribute('aria-pressed', 'true');

        if (group === 'color') {
          var color = btn.dataset.value;
          if (colorEl) colorEl.textContent = color;

          var g = document.querySelector('[data-gallery]');
          if (g) {
            g.querySelectorAll('[data-shot-color]').forEach(function (img) {
              var sc = img.dataset.shotColor;
              img.hidden = !(sc === '' || sc === color);
            });
          }

          /* Snap the gallery column back to the top so the newly chosen
             colour starts on its main image. */
          var col = document.querySelector('.tt-gallery');
          if (col) col.scrollTop = 0;

          if (copyEl && copyMap && copyMap[color]) {
            copyEl.innerHTML = copyMap[color];
          }

          reseatSize(color);
        }
        refresh();
      });
    });

    refresh();
  }

  /* ---- Size chart link opens the accordion ---- */
  var link = document.querySelector('.tt-size-link');
  if (link) {
    link.addEventListener('click', function () {
      var d = document.getElementById(link.dataset.chart);
      if (!d) return;
      d.open = true;
      d.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ---- Region gate: Canada only, once per session ---- */
  var gate = document.getElementById('tt-gate');
  if (gate) {
    var KEY = 'tantrums-region';
    var seen = null;
    try { seen = sessionStorage.getItem(KEY); } catch (e) {}

    function remember(v) { try { sessionStorage.setItem(KEY, v); } catch (e) {} }
    function close() { gate.hidden = true; document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') { remember('stay'); close(); } }

    if (!seen && gate.dataset.country === 'CA') {
      gate.hidden = false;
      document.addEventListener('keydown', onKey);
    }
    var stay = document.getElementById('tt-gate-stay');
    if (stay) stay.addEventListener('click', function () { remember('stay'); close(); });
    var go = document.getElementById('tt-gate-go');
    if (go) go.addEventListener('click', function () { remember('ca'); });
    gate.addEventListener('click', function (e) {
      if (e.target === gate) { remember('stay'); close(); }
    });
  }
})();
